<div class="changelogs-content">
  <div class="changelogs-column-left scrollable" *ngIf="changelog">
    <yo-changelogs-drop-menu
      [versions]="changelog.versions"
      [defaultVersionSelected]="versionToDisplay"
      (versionSelected)="handleVersionSelection($event)">
    </yo-changelogs-drop-menu>
  </div>
  <div class="changelogs-column-right" *ngIf="versionToDisplay">
    <yo-changelogs-details [version]="versionToDisplay"></yo-changelogs-details>
  </div>
</div>
